/* 
 * Shopify Dynamic Anniversary Text Overlay - Responsive Version
 * Text scales with image size, not viewport
 */

(function() {
  'use strict';

  // Configuration - styled to match the card
  const CONFIG = {
    // The option name in your Shopify variant
    variantOptionName: 'Anniversary Year', // Change this to match your variant option name
    
    // Text template
    textTemplate: '{year}',
    
     // Styling to match the card - elegant serif font
    // Font size as percentage of image width (3.5% works well for most cases)
     fontSizePercent: 3, // Adjust this number to make text larger/smaller
    fontFamily: '"Libre Baskerville", "Georgia", "Times New Roman", serif',
    fontWeight: '400',
    fontStyle: 'italic',
    textColor: '#17161b',
    textShadow: 'none',
    backgroundColor: 'transparent',
    padding: '0',
    borderRadius: '0',
    
    // Position to replace the text at bottom of card
    position: 'custom',
    customTop: '42.2%', // Adjust this to move text up/down
    customLeft: '39%',
 rotation: '-1.8deg', // Rotate text (negative = counterclockwise, positive = clockwise)


    // Selector for the main product image
    imageSelector: '.product__media img, .product-single__photo img, .product__main-photos img, .product-featured-img'
  };

  // Helper function to get ordinal suffix
  function getOrdinalSuffix(num) {
    const numStr = num.toString();
    const lastDigit = parseInt(numStr[numStr.length - 1]);
    const lastTwoDigits = parseInt(numStr.slice(-2));
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return num + 'th';
    }
    
    switch (lastDigit) {
      case 1: return num + 'st';
      case 2: return num + 'nd';
      case 3: return num + 'rd';
      default: return num + 'th';
    }
  }

  // Calculate font size based on container width
  function calculateFontSize(container) {
    const containerWidth = container.offsetWidth;
    return (containerWidth * CONFIG.fontSizePercent) / 100;
  }

  // Create overlay container
  function createOverlay(imageContainer) {
    const overlay = document.createElement('div');
    overlay.className = 'anniversary-overlay';
    overlay.style.cssText = `
      position: absolute;
      top: ${CONFIG.customTop};
      left: ${CONFIG.customLeft};
      transform: translate(-50%, -50%) rotate(${CONFIG.rotation});
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
      z-index: 1;
    `;

    const textBox = document.createElement('div');
    textBox.className = 'anniversary-text-box';
    textBox.style.cssText = `
      background: ${CONFIG.backgroundColor};
      padding: ${CONFIG.padding};
      border-radius: ${CONFIG.borderRadius};
    `;

    const text = document.createElement('span');
    text.className = 'anniversary-text';
    
    // Calculate initial font size
    const fontSize = calculateFontSize(imageContainer);
    
    text.style.cssText = `
      font-size: ${fontSize}px;
      font-family: ${CONFIG.fontFamily};
      font-weight: ${CONFIG.fontWeight};
      font-style: ${CONFIG.fontStyle};
      color: ${CONFIG.textColor};
      text-shadow: ${CONFIG.textShadow};
      display: block;
      text-align: center;
      line-height: 1.2;
      white-space: nowrap;
    `;

    textBox.appendChild(text);
    overlay.appendChild(textBox);
    
    return overlay;
  }

  // Update overlay text
  function updateOverlayText(text, yearValue) {
    if (!text || !yearValue) return;
    
    // Convert number to ordinal (1 -> 1st, 2 -> 2nd, etc.)
    const ordinal = getOrdinalSuffix(yearValue);
    
    // Split the template to style "1st" differently
    const templateParts = CONFIG.textTemplate.split('{year}');
    
    // Clear existing content
    text.innerHTML = '';
    
    // Create styled text: "Happy " + "1st" + " Anniversary"
    const beforeText = document.createTextNode(templateParts[0]);
    const yearSpan = document.createElement('span');
    yearSpan.style.cssText = `
      font-style: italic;
      font-weight: 700;
    `;
    yearSpan.textContent = ordinal;
    const afterText = document.createTextNode(templateParts[1] || '');
    
    text.appendChild(beforeText);
    text.appendChild(yearSpan);
    text.appendChild(afterText);
  }

  // Update font sizes on resize
  function updateFontSizes() {
    const overlays = document.querySelectorAll('.anniversary-overlay');
    overlays.forEach(overlay => {
      const imageContainer = overlay.closest('.product__media, .product-single__photo, .product__main-photos, .product-featured-media');
      if (imageContainer) {
        const text = overlay.querySelector('.anniversary-text');
        const fontSize = calculateFontSize(imageContainer);
        text.style.fontSize = fontSize + 'px';
      }
    });
  }

  // Get the year value from selected variant
  function getYearFromVariant() {
    // Method 1: Try standard Shopify variant select by ID
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const optionText = selectedOption.text;
      const match = optionText.match(/\d+/);
      if (match) {
        return match[0];
      }
    }

    // Method 2: Try to find ANY select that contains Anniversary Year or similar
    const allSelects = document.querySelectorAll('select');
    for (let select of allSelects) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) {
        const optionText = selectedOption.text;
        const optionValue = selectedOption.value;
        
        // Check if text or value contains Anniversary Year pattern
        if (optionText.includes('Anniversary') || optionText.includes('Year') || 
            optionValue.includes('Anniversary') || optionValue.includes('Year')) {
          const match = (optionText + ' ' + optionValue).match(/\d+/);
          if (match) {
            return match[0];
          }
        }
        
        // Check if the value itself is just a number
        const valueMatch = optionValue.match(/^\d+$/);
        if (valueMatch) {
          return valueMatch[0];
        }
        
        // Check if text contains a number with ordinal (1st, 2nd, etc)
        const ordinalMatch = optionText.match(/(\d+)(st|nd|rd|th)/);
        if (ordinalMatch) {
          return ordinalMatch[1];
        }
      }
    }

    // Method 3: Try radio buttons or swatches
    const selectedOption = document.querySelector(`input[name*="${CONFIG.variantOptionName}"]:checked`);
    if (selectedOption) {
      const value = selectedOption.value;
      const match = value.match(/\d+/);
      if (match) {
        return match[0];
      }
    }

    // Method 4: Try active swatch
    const activeSwatch = document.querySelector('.swatch-element.selected, .variant-option.selected');
    if (activeSwatch) {
      const match = activeSwatch.textContent.match(/\d+/);
      if (match) {
        return match[0];
      }
    }

    // Method 5: Check for selected option in any dropdown with a number
    const allOptions = document.querySelectorAll('option:checked, option[selected]');
    for (let option of allOptions) {
      const text = option.textContent;
      const value = option.value;
      const match = (text + ' ' + value).match(/\d+/);
      if (match) {
        return match[0];
      }
    }

    return null;
  }

  // Initialize overlay on product image
  function initializeOverlay() {
    // Find the main product image container - only target the FIRST one
    const imageElements = document.querySelectorAll(CONFIG.imageSelector);
    
    // Only add overlay to the FIRST main image (not thumbnails or gallery images)
    if (imageElements.length > 0) {
      const img = imageElements[0]; // Only use the first image
      const imageContainer = img.closest('.product__media, .product-single__photo, .product__main-photos, .product-featured-media') || img.parentElement;
      
      // Make sure container is positioned
      if (imageContainer && getComputedStyle(imageContainer).position === 'static') {
        imageContainer.style.position = 'relative';
      }

      // Check if overlay already exists
      if (imageContainer && !imageContainer.querySelector('.anniversary-overlay')) {
        const overlay = createOverlay(imageContainer);
        imageContainer.appendChild(overlay);
        
        // Update text based on current variant
        const yearValue = getYearFromVariant();
        const textElement = overlay.querySelector('.anniversary-text');
        if (yearValue) {
          updateOverlayText(textElement, yearValue);
        }
      }
    }
  }

  // Update all overlays when variant changes
  function updateAllOverlays() {
    const yearValue = getYearFromVariant();
    const textElements = document.querySelectorAll('.anniversary-text');
    
    textElements.forEach(text => {
      if (yearValue) {
        updateOverlayText(text, yearValue);
      }
    });
  }

  // Listen for variant changes
  function setupVariantListeners() {
    // Listen for select changes
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', updateAllOverlays);
    }

    // Listen for radio/swatch changes
    const variantInputs = document.querySelectorAll('input[name*="option"], .swatch input, .variant-option');
    variantInputs.forEach(input => {
      input.addEventListener('change', updateAllOverlays);
      input.addEventListener('click', updateAllOverlays);
    });

    // Listen for Shopify variant change events
    document.addEventListener('variant:change', updateAllOverlays);
    document.addEventListener('variantChange', updateAllOverlays);
    
    // Listen for form changes (some themes use this)
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', updateAllOverlays);
    }
    
    // Listen for ANY select change on the page (broader net)
    document.addEventListener('change', function(e) {
      if (e.target.matches('select') || e.target.matches('input[type="radio"]')) {
        setTimeout(updateAllOverlays, 50);
      }
    });
    
    // Watch for mutations in the DOM (for dynamic variant selectors)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          setTimeout(updateAllOverlays, 50);
        }
      });
    });
    
    // Observe variant selector areas
    const variantArea = document.querySelector('.product-form, .product-single, .product__info-wrapper');
    if (variantArea) {
      observer.observe(variantArea, { 
        attributes: true, 
        childList: true, 
        subtree: true,
        attributeFilter: ['class', 'data-selected']
      });
    }
    
    // Listen for window resize to update font sizes
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateFontSizes, 100);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeOverlay();
      setupVariantListeners();
    });
  } else {
    initializeOverlay();
    setupVariantListeners();
  }

  // Re-initialize if Shopify section is reloaded
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      initializeOverlay();
      setupVariantListeners();
    }, 100);
  });

})();